import React from 'react';
import PropTypes from 'prop-types';
import SectionHeading from '../../SectionHeading/SectionHeading';
import RadioGroup from '../../RadioGroup/RadioGroup';
import ImportantInfo from './ImportantInfo';
import './BringYourOwnModem.scss';

const BringYourOwnModem = (props) => {
  const { isByoModemSelected, setByoModemSelected, handleChange, isImportantInfoTickbox } = props;
  const byoRadios = () => [
    {
      id: 'byo-no',
      label: 'No, I want a new modem',
      value: false,
    },
    {
      id: 'byo-yes',
      label: 'Yes, I want to bring my own modem',
      value: true
    }
  ];

  return (
    <div className="byo-selection">
      <div className="container">
        <div className="row">
          <div className="col-lg-8">
            <SectionHeading
              number={3}
              title={'Do you want to bring your own modem?'}
              description={'Save $5 per month for 12 months (and create less e-waste!) when you bring your own compatible modem.'}
              titleClassName={'byo-section-title selection-section-title'}
              numberClassName={'selection-heading-number'}
            />
            <RadioGroup
              vertical
              name={'byo'}
              radioButtons={byoRadios()}
              selectedValue={isByoModemSelected}
              onChange={setByoModemSelected}
            />
            {isByoModemSelected && <ImportantInfo handleChange={handleChange} isImportantInfoTickbox={isImportantInfoTickbox} />}
          </div>
        </div>
      </div>
    </div>
  );
};

BringYourOwnModem.propTypes = {
  isByoModemSelected: PropTypes.bool,
  isImportantInfoTickbox: PropTypes.bool,
  setByoModemSelected: PropTypes.func,
  handleChange: PropTypes.func
};
export default BringYourOwnModem;



/** WEBPACK FOOTER **
 ** ./src/components/Plans/BringYourOwnModem/BringYourOwnModem.js
 **/